import { useNavigate } from "react-router-dom";

import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { PRINT_DOWNLOAD_DATA, GET_INVOICE_DATA_BY_INVOICE_NO } from '../../../common/URLs';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD } from "../../../common/constants";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Fab, Typography, Button, Grid, Stack, Divider, CardContent, Card, Container, Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { v4 as uuidv4 } from 'uuid';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import apiClient from "../../../axios";

export function TrInvoice() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const invoiceData = useLocation().state?.selectedRow;
  const invoiceNumber = invoiceData?.invoiceNo ? invoiceData?.invoiceNo : invoiceData?.pitInvoiceNumber;
  const [trInvoiceDetails, settrInvoiceDetails] = useState();
  const [downloadinvoice, setDownloadinvoice] = useState();
  const { state } = useLocation();
  const tabValue = useLocation().state.tabValue;
  const pageName = useLocation().state.pageName;

  const goBack = () => {
    if (state?.screen === "invoicePayment" || state?.screen === "invoice" || state?.pageName === "invoicePayment") {
        navigate('/paymentDashboard/invoicePayment', {
          state: { 
            tabValue: state?.tabValue, 
            stakeholderType: state?.stakeholderType ,
            openGroupId: state?.openGroupId
          }
        });
      }
    else if (pageName == "invoiceList") {
      navigate('../invoiceList', { state: { tabValue: tabValue, materialTabValue: state?.materialTabValue } });
    }
    else {
      navigate(-1);
    }
  }
  useEffect(() => {
    getInvoiceDetails();
  }, []);
  const getInvoiceDetails = () => {
    let data = {
      invoiceNo: invoiceNumber
    }
    let headers = {
      Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
    }
    apiClient
      .post(GET_INVOICE_DATA_BY_INVOICE_NO, data, { headers })
      .then(res => {
        settrInvoiceDetails(res.data.invoiceDetails);
      })
  }

  const getDownloadinvoice = (action) => {
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": invoiceNumber,
          "printDetailsType": "hit_invoice"
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadinvoice(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);

          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }

        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const columns = [
    // { field: 'scheduleLineNumber', headerName: t('pit.lineNo'), width: 100 },

    {
      field: 'itemCode',
      headerName: t('pit.itemCode'),
      width: 100,
      valueGetter: (params) => {
        return params.row?.materialType === "RawBamboo" ? "RB" : "CB";
      }
    },

    { field: 'materialType', headerName: t('pit.ItemDescHSNCode'), width: 200 },
    { field: 'quantity', headerName: t('pit.quantity'), width: 100 },
    { field: 'uom', headerName: t('pit.uom'), width: 100 },
    { field: 'sourceAddress', headerName: "Pick-up Location (Name & Address)", width: 200 },

    // {
    //   field: 'pickUpDate',
    //   headerName: "Pick-up Date",
    //   width: 200,
    //   valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    // },

    { field: 'destinationAddress', headerName: "Delivery Location(Name & Address)", width: 150 },

    // {
    //   field: 'deliveryDate',
    //   headerName: "Delivery Date",
    //   width: 100,
    //   valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    // },

    { field: 'unitPrice', headerName: t('pit.price'), width: 100 },
    { field: 'unitDesc', headerName: t('pit.unitPer'), width: 100 },
    { field: 'itemType', headerName: t('pit.itemType'), width: 100 },

    { field: 'invoiceAmount', headerName: t('pit.invoiceAmount'), width: 180 },

    { field: 'cgst', headerName: t('pit.cgst'), width: 100 },
    { field: 'sgst', headerName: t('pit.sgst'), width: 100 },
    { field: 'igst', headerName: t('pit.igst'), width: 100 },
    { field: 'tdsTax', headerName: 'TDS Tax (INR)', width: 100 },
    { field: 'invoiceTax', headerName: 'GST (INR)', width: 150 },
    {
      field: 'total',
      headerName: 'Total Invoice Amount (Inc. Taxes) (INR)',
      width: 210
    },

    {
      field: 'netAmountPayable',
      headerName: 'Net Amount Payable (INR)',
      width: 180,
    }
  ];

  return (
    <Container maxWidth="xxl">
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT26</p>}
      <Typography variant="h4" sx={{ mb: 2 }}>
        <Fab onClick={() => { goBack() }} size="small" aria-label="back" title='Back'>
          <KeyboardArrowLeftRounded />
        </Fab> TR Invoice
      </Typography>
      <Card>
        <CardContent>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} divider={<Divider orientation="vertical" flexItem />}>
            <Stack direction="column">
              {/* <Typography variant="subtitle1" gutterBottom>{t('pit.invoiceDetails')}</Typography> */}
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.invoiceNo')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.invoiceNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.invoiceDate')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {moment(trInvoiceDetails?.invoiceDate).format("DD/MM/YYYY")}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.vendorName')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorName}
                </Typography>
              </Stack>
              {/* <Stack direction="row">
                <Typography variant="subtitle2" sx={{display: "inline", whiteSpace: "nowrap"}} gutterBottom>{t('pit.consignment')}: </Typography>
                <Typography style={{ display: "inline", whiteSpace: "nowrap" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.consignmentNo}
                </Typography>
              </Stack> */}
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.invoiceType')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {invoiceData?.invoiceType}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="column">
              <Typography variant="subtitle1" gutterBottom>{t('pit.vendorDetails')}</Typography>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.name')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorName}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.urn')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorUrn}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" style={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.contactPerson')}: </Typography>
                <Typography style={{ display: "inline", whiteSpace: "nowrap" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorContactName}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" style={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.phoneNumber')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorContactNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.address')}: </Typography>
                <Typography style={{ display: "inline", wordBreak: 'break-all' }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorAddress}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.gstIn')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.vendorGSTIN}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="column">
              <Typography variant="subtitle1" gutterBottom>{t('pit.customerDetails')}</Typography>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.name')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.customerName}
                </Typography>
              </Stack>
              {/* <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.urn')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.customerUrn}
                </Typography>
              </Stack> */}
              <Stack direction="row">
                <Typography variant="subtitle2" style={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.contactPerson')}: </Typography>
                <Typography style={{ display: "inline", whiteSpace: "nowrap" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.customerContactPerson}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" style={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>{t('pit.phoneNumber')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.customerContactNo}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.address')}: </Typography>
                <Typography style={{ display: "inline", wordBreak: 'break-all' }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.customereAddress}
                </Typography>
              </Stack>
              <Stack direction="row">
                <Typography variant="subtitle2" gutterBottom>{t('pit.gstIn')}: </Typography>
                <Typography style={{ display: "inline" }} ml={1} variant="body2" gutterBottom>
                  {trInvoiceDetails?.customerGSTIN}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <DataGrid style={{ marginTop: "4vh" }}
            autoHeight
            rows={trInvoiceDetails?.invoiceSourceDestination ? trInvoiceDetails?.invoiceSourceDestination.map((item) => ({ ...item, id: uuidv4() })) : []}
            columns={columns}
            pageSize={10}
            components={{ Toolbar: QuickSearchToolbar }}
          />
          {/* <tr>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'></td>
<td className='common-table-heading-text'>{t('pit.sumTotal')}</td>
<td className='common-table-heading-text'>{trInvoiceDetails?.unitPrice}</td>
<td className='common-table-heading-text'>{trInvoiceDetails?.totalAmount}</td>
<td className='common-table-heading-text'>{trInvoiceDetails?.totalIGST}</td>
<td className='common-table-heading-text'>{trInvoiceDetails?.totalSGST}</td>
<td className='common-table-heading-text'>{trInvoiceDetails?.totalGST}</td>
<td className='common-table-heading-text'>{trInvoiceDetails?.totalAmount}</td>
</tr> */}


        </CardContent>
      </Card>
      <Box display='flex' justifyContent="flex-end" mt={2}>
        <Button variant="contained" onClick={() => getDownloadinvoice("download")}>{t('pit.download')}</Button>
        <Button variant="contained" sx={{ ml: 2 }} onClick={() => getDownloadinvoice("print")}>{t('pit.print')}</Button>
      </Box>
    </Container>
  )
}
export default TrInvoice;